import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { NotificationsToolbarComponent } from './notifications-toolbar.component';
import { MatIconModule, MatMenuModule, MatButtonModule, MatBadgeModule } from '@angular/material';

@NgModule({
    declarations: [
        NotificationsToolbarComponent
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        RouterModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatBadgeModule
    ],
    exports: [
        NotificationsToolbarComponent
    ]
})

export class NotificationsToolbarModule {
}
